export default "__VITE_ASSET__DkN66flo__"